/**
 * Tiny className joiner. Kept dependency-free (no clsx/tailwind-merge) so the
 * landing page ships with the smallest possible bundle.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
